import { Text } from '@chakra-ui/layout';
import { Flex, FlexProps } from '@chakra-ui/react';
import Image, { StaticImageData } from 'next/image';
import { FC } from 'react';

interface IWhyReasons extends FlexProps {
  src: StaticImageData;
  alt: string;
  title: string;
  description: string;
}

export const WhyReasons: FC<IWhyReasons> = ({ src, alt, title, description, ...rest }) => {
  return (
    <Flex w="full" alignItems="center" flexDirection="column" {...rest}>
      <Image width={110} height={110} src={src} alt={alt} />
      <Text fontSize="lg" mt={4} mb={2} fontWeight="bold" fontFamily="heading">
        {title}
      </Text>
      <Text fontSize="lg" textAlign="center">
        {description}
      </Text>
    </Flex>
  );
};
